
function fn () {

    this.$eventBus.emit('show-dialog-page', {
      page: 'fatture-vendita-check-sdd-xml',
      title: 'Check Xml Sdd',
      maximize: false,
    })
}

export default {
  'bindTo': 'this',
  'method': fn,
}
